import { render, staticRenderFns } from "./CadList.vue?vue&type=template&id=74f1f244&scoped=true"
import script from "./CadList.vue?vue&type=script&lang=js"
export * from "./CadList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74f1f244",
  null
  
)

export default component.exports